<template>
  <div class="get-code" :style="{cursor: (code === 'Send Code' || code === '获取验证码' ? 'pointer' : 'not-allowed')}" @click="sendCode">
    {{code}}
  </div>
</template>

<script>
  import { post } from '../common/Axios.js'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  import translate from '../common/Translate.js'
  import { getLocationHash, browserLanguage } from '../common/Common.js'
  export default {
    data () {
      return {
        code: translate('Send Code'),
        account: this.$route.query.account,
        countryCode: this.$route.query.countryCode,
        isEmail: this.$route.query.isEmail
      }
    },
    props: ['type', 'data'],
    mounted () {
    },
    methods: {
      // 点击获取验证码
      async sendCode () {
        if (this.code === 'Send Code' || this.code === '获取验证码') {
          let sec = 60
          this.code = sec + 's'
          let time = setInterval(() => {
            sec--
            this.code = sec + 's'
            if (sec === 0) {
              clearInterval(time)
              this.code = translate('Send Code')
            }
          }, 1000)
          if (this.isEmail === true || this.isEmail === 'true') {
            uploadWebEvent('EMAIL_SEND_CODE') // 埋点统计：邮箱重置密码页面获取验证码
            await post('/proxy-api/client/web/index/send-email-capture', {email: this.account})
          } else {
            if (this.$route.name === 'Signupphone') {
              uploadWebEvent('PHONE_SIGNUP_SEND_CODE') // 埋点统计：手机号注册点击获取手机验证码
            } else if (this.$route.name === 'ForgotPassword') {
              uploadWebEvent('PHONE_RESET_SEND_CODE') // 埋点统计：手机号重置密码页面获取验证码
            } else if (this.$route.name === 'InvitePhone') {
              uploadWebEvent('PHONE_INVITE_SEND_CODE') // 埋点统计：手机号邀请注册页面获取验证码
            }
            let that = this
            let callback = function (msg, status) {
              if (status !== '0') {
                that.$emit('openErrorTip', msg)
                clearInterval(time)
                that.code = translate('Send Code')
              }
            }
            await post('/proxy-api/client/phone/index/send-capture', {phone_num: this.data.phone || this.account, type: +this.type, country_code: this.data.countryCode || '', language: browserLanguage()}, callback, getLocationHash())
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
	.get-code {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #3f86de;
    border: 1px solid #3f86de;
    border-radius: 2px;
    -webkit-user-select: none;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// GetCode.vue?17f420ec